<div class="navbg">
  <nav class="">
    <div class="container">
      <div class="row">
        <div class="col-sm-2 col-5">
          <a class="navbar-brand" routerLink="/" *ngIf="isActive==false">
            <img src="../../../../assets/images/logo-white.png" class="logo" />
          </a>
          <span *ngIf="isActive==true">
            <a class="navbar-brand" routerLink="/recruiter" *ngIf="authService.session.profile.admin==1 || authService.session.profile.company==1">
              <img src="../../../../assets/images/logo-white.png" class="logo" />
            </a>
            <a class="navbar-brand" routerLink="/profile" [hidden]="authService.session.profile.admin==1 || authService.session.profile.company==1">
              <img src="../../../../assets/images/logo-white.png" class="logo" />
            </a>
          </span>
        </div>
        <div class="col-sm-10 col-7 text-right">
          <div class="nav navbar">
            <ul class="list-inline">
              <li class="list-inline-item"><a class="btn btn-outline-primary btn-job" routerLink="/job"><span class="hidden-xs">Find </span>Jobs</a></li>
              <li class="list-inline-item" [hidden]="authService.session.isActive">
                <button class="btn btn-outline-primary btn-login" routerLink="/login">Login</button>
              </li>
              <li class="list-inline-item">
                <div class="header__profile" *ngIf="authService.session.isActive==true">
                  <div ngbDropdown class="d-inline-block">
                    <a ngbDropdownToggle class="cursor header__name">
                      <span class="header__name--welcome hidden-xs">Hi, {{profile.first_name}}</span>
                      <div class="header__profile--block">
                        <img src="{{profile.profile_pic || '../../../../assets/images/profile.png'}}" class="header__profile&#45;&#45;bg">
                      </div>
                    </a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="dropdownBasic1">
                      <button class="dropdown-item" routerLink="/profile" *ngIf="authService.session.profile.admin==0 && authService.session.profile.company==0">Dashboard</button>
                      <button class="dropdown-item" routerLink="/recruiter" *ngIf="authService.session.profile.admin==1 || authService.session.profile.company==1">Dashboard</button>
                      <button class="dropdown-item" routerLink="/company" *ngIf="authService.session.profile.admin==1 || authService.session.profile.company==1">Company</button>
                      <button class="dropdown-item" routerLink="/profile/applied-job" *ngIf="authService.session.profile.admin==0 && authService.session.profile.company==0">Applied Jobs</button>
                      <button class="dropdown-item" routerLink="/profile/edit">Settings</button>
                      <button class="dropdown-item" routerLink="/profile/security">Security</button>
                      <button class="dropdown-item" (click)="logout()">Logout</button>
                    </div>
                  </div>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </nav>
</div>
